<template>
    <NavBar />

    <!-- CONTENT -->
    <section class="pt-8 pt-md-11 pb-8 pb-md-14">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md">

                    <!-- Heading -->
                    <h1 class="display-4 mb-2">
                        Allgemeine Geschäftsbedingungen
                    </h1>

                    <!-- Text -->
                    <p class="fs-lg text-gray-700 mb-md-0">
                        Stand: Juli 2026
                    </p>

                </div>
                <div class="col-auto">

                    <!-- Buttons -->
                    <a href="#!" class="btn btn-primary-subtle" @click.prevent="printPage">
                        Drucken
                    </a>

                </div>
            </div> <!-- / .row -->
            <div class="row">
                <div class="col-12">

                    <!-- Divider -->
                    <hr class="my-6 my-md-8">

                </div>
            </div> <!-- / .row -->
            <div class="row">
                <div class="col-12 col-md-8">

                    <!-- Text -->
                    <p class="fs-lg text-gray-800 mb-6 mb-md-8">
                        Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB“) gelten für die Nutzung der
                        Webapplikation <strong>AllDayCare</strong>. Bitte lesen Sie diese Bedingungen sorgfältig, bevor
                        Sie den Dienst nutzen.
                    </p>

                    <h3 class="mb-5">
                        § 1 Geltungsbereich
                    </h3>

                    <p class="text-gray-800">
                        Diese Allgemeinen Geschäftsbedingungen (im Folgenden „AGB“) gelten, sofern nicht ausdrücklich
                        etwas anderes vereinbart ist, für alle Geschäftsbeziehungen und Verträge von Ingo Weber (im
                        Folgenden „AllDayCare“) mit dem Vertragspartner (im Folgenden „Vertragspartner“ oder „Kunde“).
                    </p>

                    <p class="text-gray-800">
                        Die AGB gelten ausschließlich gegenüber Unternehmern im Sinne des § 14 BGB, juristischen
                        Personen des öffentlichen Rechts und öffentlich-rechtlichen Sondervermögen. Ein Vertragsschluss
                        mit Verbrauchern im Sinne des § 13 BGB ist nicht vorgesehen.
                    </p>

                    <p class="text-gray-800">
                        Die AGB werden dem Vertragspartner vor Vertragsschluss zugänglich gemacht; er hat die
                        Möglichkeit, sie abzurufen, zu speichern und auszudrucken. Mit Vertragsschluss werden die AGB in
                        ihrer zu diesem Zeitpunkt gültigen Fassung Vertragsbestandteil.
                    </p>

                    <h3 class="mb-5 mt-7">
                        § 2 Vertragsgegenstand
                    </h3>

                    <p class="text-gray-800">
                        Der Vertragspartner erhält für die Dauer des Vertrages ein einfaches (nicht ausschließliches),
                        nicht übertragbares und nicht unterlizenzierbares Recht, die Webapplikation AllDayCare
                        (nachfolgend „Software“) im vertragsgemäßen Umfang zu nutzen. Das Nutzungsrecht endet mit
                        Beendigung des Vertrages.
                    </p>

                    <p class="text-gray-800">
                        Gegenstand des Vertrags ist die Nutzung der Webapplikation. Die Webapplikation ermöglicht dem
                        Kunden die Verwaltung und Organisation seines Unternehmens. Der Kunde und die von ihm bestimmten
                        Mitarbeiter erhalten hierzu Zugang zur Webapplikation.
                    </p>

                    <p class="text-gray-800">
                        Der Umfang der geschuldeten Leistung ergibt sich aus der bei Vertragsschluss gültigen
                        <a href="/functions">Funktionsübersicht</a>, die insoweit verbindlich ist. Maßgeblich ist die zu
                        diesem Zeitpunkt gültige Fassung.
                    </p>

                    <p class="text-gray-800">
                        AllDayCare ist berechtigt, die Software weiterzuentwickeln und einzelne Funktionen zu
                        aktualisieren oder anzupassen, soweit dies aus sachlichem Grund (z. B. technische
                        Weiterentwicklung, Sicherheit, geänderte Rechtslage) erfolgt und die wesentlichen gebuchten
                        Funktionen sowie der Vertragszweck hierdurch nicht beeinträchtigt werden. Bei einer erheblichen
                        und für den Kunden nachteiligen Änderung wesentlicher Funktionen steht dem Kunden ein
                        Sonderkündigungsrecht zu.
                    </p>

                    <p class="text-gray-800">
                        Soweit Wartungsarbeiten am System durchgeführt werden, wird der Kunde nach Möglichkeit
                        rechtzeitig vorher per E-Mail über den voraussichtlichen Beginn und das voraussichtliche Ende
                        dieser Wartungsarbeiten informiert. Während des Zeitraums der Wartungsarbeiten ist die
                        Webapplikation nicht erreichbar.
                    </p>

                    <p class="text-gray-800">
                        AllDayCare weist ausdrücklich darauf hin, dass die Datenübertragung im Internet (z. B. bei der
                        Kommunikation per E-Mail) Sicherheitslücken aufweisen und nicht lückenlos vor dem Zugriff durch
                        Dritte geschützt werden kann.
                    </p>

                    <p class="text-gray-800">
                        Unabhängig hiervon trifft AllDayCare für die eigenen Systeme dem Stand der Technik und dem
                        jeweiligen Risiko angemessene technische und organisatorische Maßnahmen, um die Vertraulichkeit,
                        Integrität, Verfügbarkeit und Belastbarkeit der Systeme und Daten zu schützen (vgl. Art. 32
                        DSGVO).
                    </p>

                    <p class="text-gray-800">
                        Das Programm, dessen Auswertungen und die Dokumentation unterliegen dem Urheberschutz.
                    </p>

                    <h3 class="mb-5 mt-7">
                        § 3 Vertragsschluss, Datenverarbeitung und Vertragsänderungen
                    </h3>

                    <p class="text-gray-800">
                        Die Registrierung bzw. Bestellung durch den Kunden stellt ein Angebot auf Abschluss des
                        Nutzungsvertrages dar. Der Nutzungsvertrag kommt erst mit ausdrücklicher Bestätigung (Annahme)
                        durch AllDayCare in Textform oder mit der Freischaltung des Zugangs zustande. Eine automatisierte
                        Eingangsbestätigung der Registrierung stellt noch keine Annahme dar.
                    </p>

                    <p class="text-gray-800">
                        Soweit AllDayCare im Rahmen der Leistungserbringung personenbezogene Daten im Auftrag des Kunden
                        verarbeitet, erfolgt dies auf Grundlage eines gesondert abzuschließenden Vertrags zur
                        Auftragsverarbeitung nach Art. 28 DSGVO. Dieser regelt insbesondere Gegenstand, Umfang,
                        Weisungsbindung, technische und organisatorische Maßnahmen, den Einsatz von Unterauftragnehmern,
                        den Speicherort sowie die Rückgabe oder Löschung der Daten. Der Kunde bleibt als Verantwortlicher
                        für die Rechtmäßigkeit der Verarbeitung zuständig.
                    </p>

                    <p class="text-gray-800">
                        AllDayCare kann die Nutzung der Webapplikation oder einzelner Funktionen oder den Umfang, in dem
                        einzelne Funktionen und Services genutzt werden können, an bestimmte Voraussetzungen knüpfen,
                        wie z. B. Prüfung der Anmeldedaten, Zahlung des monatlichen Entgeltes oder eine anlassbezogene
                        Bonitätsprüfung, soweit diese für die Vertragsdurchführung erforderlich ist.
                    </p>

                    <p class="text-gray-800">
                        Der Vertragsabschluss erfolgt ausschließlich mit Unternehmern im Sinne des § 14 BGB. Mit der
                        Bestellung bestätigt der Kunde, dass er den Vertrag in Ausübung seiner gewerblichen oder
                        selbständigen beruflichen Tätigkeit abschließt.
                    </p>

                    <p class="text-gray-800">
                        Erst nach Vertragsabschluss wird der Kunde auf der Webapplikation freigeschaltet. Der Kunde
                        erhält eine Einladung per E-Mail an die angegebene E-Mail-Adresse, über die er sein persönliches
                        Passwort selbst festlegen kann. Der Kunde ist verpflichtet, seine Zugangsdaten geheim zu halten
                        und vor dem Zugriff Dritter zu schützen.
                    </p>

                    <p class="text-gray-800">
                        AllDayCare kann diese AGB für die Zukunft anpassen, soweit hierfür ein sachlicher Grund besteht
                        (insbesondere Änderungen der Rechtslage, höchstrichterlicher Rechtsprechung, technische
                        Weiterentwicklung oder Anpassung an geänderte Marktverhältnisse) und die Anpassung den Kunden
                        nicht unangemessen benachteiligt. Änderungen des Verhältnisses von Leistung und Gegenleistung
                        (insbesondere des Preises) sowie der wesentlichen (kardinalen) Vertragspflichten sind hiervon
                        ausgenommen und bedürfen einer ausdrücklichen Vereinbarung.
                    </p>

                    <p class="text-gray-800">
                        Beabsichtigte Änderungen teilt AllDayCare dem Kunden mindestens sechs Wochen vor ihrem
                        Wirksamwerden in Textform mit und weist dabei gesondert und hervorgehoben auf die Änderungen, die
                        Widerspruchsmöglichkeit, die Frist und die Folgen des Schweigens hin. Widerspricht der Kunde
                        nicht bis zum Wirksamwerden, gelten die Änderungen als angenommen. Widerspricht der Kunde, kann
                        jede Partei den Vertrag zum Zeitpunkt des geplanten Wirksamwerdens außerordentlich kündigen.
                        Rückwirkende Änderungen sind ausgeschlossen.
                    </p>

                    <h3 class="mb-5 mt-7">
                        § 4 Mietpreis
                    </h3>

                    <p class="text-gray-800">
                        Der Mietpreis, inklusive Wartungsgebühren, beträgt <strong>0,50 € pro abgerechnetem
                        (aktivem) Kunden* und Monat</strong>.
                    </p>

                    <p class="text-gray-800">
                        Die Abrechnung erfolgt – nach der bei Vertragsabschluss getroffenen Vereinbarung – wahlweise:
                    </p>

                    <ul class="text-gray-800">
                        <li>
                            <strong>monatlich</strong> auf Grundlage der tatsächlichen Anzahl aktiver Kunden* im
                            jeweiligen Abrechnungsmonat, oder
                        </li>
                        <li>
                            <strong>im Jahresdurchschnitt</strong> auf Grundlage der über das Kalenderjahr gemittelten
                            Anzahl aktiver Kunden*.
                        </li>
                    </ul>

                    <p class="text-gray-800">
                        <small>
                            * Als „aktiver Kunde“ gilt ein Kunde, für den im jeweiligen Abrechnungsmonat mindestens ein
                            Beleg verrechnet wurde. Maßgeblich für die Abrechnung ist ausschließlich die tatsächliche
                            Verrechnung mindestens eines Belegs im betreffenden Monat; der bloße Status „Aktiv“ führt
                            für sich genommen nicht zur Abrechnung. Die Auswertung erfolgt automatisiert durch das
                            System; die Abrechnungsgrundlage (Anzahl und Zuordnung der abgerechneten Kunden) wird dem
                            Kunden mit der Abrechnung nachvollziehbar ausgewiesen.
                        </small>
                    </p>

                    <p class="text-gray-800">
                        <small>
                            Dem Kunden steht das Recht zu, die Abrechnung binnen 30 Tagen ab Zugang zu prüfen und
                            begründete Einwendungen in Textform zu erheben. Nachträgliche Statusänderungen oder erkannte
                            Auswertungsfehler werden in der folgenden Abrechnung korrigiert. Ein Kunde wird nicht als
                            aktiv gewertet, wenn für ihn im betreffenden Monat kein Beleg verrechnet wurde (z. B. bei
                            Status Proforma, Gekündigt oder Verstorben).
                        </small>
                    </p>

                    <p class="text-gray-800">
                        <small>
                            Wird die Abrechnung im Jahresdurchschnitt vereinbart, ergibt sich die maßgebliche Kundenzahl
                            aus dem Durchschnitt der je Monat abgerechneten aktiven Kunden über die Vertragsmonate des
                            Kalenderjahres (Summe der monatlich abgerechneten aktiven Kunden geteilt durch die Anzahl der
                            Vertragsmonate im Kalenderjahr, kaufmännisch gerundet). Beginnt oder endet der Vertrag im
                            laufenden Jahr, werden nur die tatsächlichen Vertragsmonate berücksichtigt.
                        </small>
                    </p>

                    <p class="text-gray-800">
                        <b>Alle Preise verstehen sich als Nettopreise.</b> AllDayCare ist derzeit Kleinunternehmer im
                        Sinne des § 19 UStG; es wird daher keine Umsatzsteuer ausgewiesen oder berechnet.
                    </p>

                    <p class="text-gray-800">
                        <small>
                            Soweit künftig Umsatzsteuer gesetzlich anfällt – etwa bei Wegfall der
                            Kleinunternehmerregelung –, wird sie zusätzlich in der jeweils geltenden gesetzlichen Höhe
                            berechnet.
                        </small>
                    </p>

                    <h3 class="mb-5 mt-7">
                        § 5 Dauer des Vertrages
                    </h3>

                    <p class="text-gray-800">
                        Der Vertrag ist unbefristet.
                    </p>

                    <p class="text-gray-800">
                        Die Kündigung ist mit einer Frist von vierzehn Tagen zum Monatsende möglich.
                    </p>

                    <p class="text-gray-800">
                        Ab dem Datum des Vertragsendes werden alle aktiven Zugänge des Kunden automatisch gesperrt.
                    </p>

                    <p class="text-gray-800">
                        Das Recht beider Parteien zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
                    </p>

                    <p class="text-gray-800">
                        AllDayCare stellt dem Kunden auf Anfrage innerhalb von 30 Tagen ab Vertragsende dessen im System
                        gespeicherte Daten einmalig in einem gängigen, maschinenlesbaren Format zur Verfügung
                        (Datenherausgabe). Nach Ablauf dieser Frist werden die Daten des Kunden – vorbehaltlich
                        gesetzlicher Aufbewahrungspflichten sowie der Regelungen des Auftragsverarbeitungsvertrages –
                        gelöscht.
                    </p>

                    <h3 class="mb-5 mt-7">
                        § 6 Betriebsstätte
                    </h3>

                    <p class="text-gray-800">
                        Die Nutzung der Webapplikation ist ortsunabhängig, insbesondere auch aus mehreren
                        Niederlassungen des Kunden sowie im mobilen Arbeiten oder Homeoffice zulässig, sofern die Nutzung
                        dem Unternehmen des Kunden dient und der vertragsgemäße Nutzungsumfang (§ 7) eingehalten wird.
                        Eine zusätzliche Vergütung je Standort fällt nicht an; die Vergütung richtet sich ausschließlich
                        nach § 4.
                    </p>

                    <h3 class="mb-5 mt-7">
                        § 7 Nutzungsumfang
                    </h3>

                    <p class="text-gray-800">
                        Der Kunde darf die Software und ihre Ergebnisse ausschließlich für die eigenen betrieblichen
                        Zwecke seines Unternehmens nutzen. Die Nutzung durch eigene Beschäftigte sowie durch beauftragte
                        Dienstleister (z. B. Steuerberater) im Rahmen ihrer Tätigkeit für den Kunden ist zulässig, soweit
                        dies für die vertragsgemäße Nutzung erforderlich ist.
                    </p>

                    <p class="text-gray-800">
                        Eine Überlassung der Software oder ihrer Ergebnisse an Dritte zur eigenen gewerblichen Nutzung –
                        auch an rechtlich selbständige, mit dem Kunden verbundene Unternehmen oder an weitere Unternehmen
                        desselben Inhabers – ist ohne vorherige Zustimmung von AllDayCare nicht zulässig.
                    </p>

                    <p class="text-gray-800">
                        Zu den erlaubten Vervielfältigungen zählen das Anzeigen der Webapplikation auf der vom Kunden zu
                        bestimmenden Datenverarbeitungseinheit, das Fertigen von Ausdrucken und Kopien im vertragsgemäßen
                        Umfang.
                    </p>

                    <h3 class="mb-5 mt-7">
                        § 8 Zahlungsweise
                    </h3>

                    <p class="text-gray-800">
                        Bei monatlicher Abrechnung wird der Mietpreis nachträglich auf Grundlage der im jeweiligen Monat
                        abgerechneten aktiven Kunden ermittelt. Der Kunde erhält hierüber eine Rechnung bzw. eine
                        nachvollziehbare Abrechnungsübersicht; der Rechnungsbetrag ist binnen 14 Tagen ab Zugang der
                        Rechnung fällig.
                    </p>

                    <p class="text-gray-800">
                        Bei Abrechnung im Jahresdurchschnitt kann AllDayCare monatliche Abschläge auf Grundlage der
                        abgerechneten Kundenzahl des Vormonats erheben und am Jahresende auf Basis des tatsächlichen
                        Jahresdurchschnitts (§ 4) abrechnen. Eine sich ergebende Differenz wird ausgeglichen
                        (Nachberechnung oder Erstattung).
                    </p>

                    <p class="text-gray-800">
                        Zahlungen sind ausschließlich auf das von AllDayCare mitgeteilte Konto zu erbringen. Die
                        maßgebliche Bankverbindung wird dem Kunden bei Vertragsschluss und auf der Rechnung mitgeteilt.
                        Der Kunde kann die Rechtzeitigkeit der Zahlung durch Einrichten eines Dauerauftrages
                        sicherstellen.
                    </p>

                    <p class="text-gray-800">
                        Die Geschwindigkeit der Datenübertragung ist wesentlich von der Verbindungsleitung des Kunden
                        zum Internet abhängig.
                    </p>

                    <p class="text-gray-800">
                        Sämtliche für den Betrieb der Webapplikation serverseitig erforderlichen Lizenzen (insbesondere
                        Datenbank- und Applikationsserver-Lizenzen) sind im Mietpreis enthalten. Nicht zum
                        Leistungsumfang gehören Hard- und Software sowie Lizenzen, die auf Seiten des Kunden für den
                        Zugriff erforderlich sind (z. B. Endgeräte, Betriebssystem, Internetzugang, Browser).
                    </p>

                    <p class="text-gray-800">
                        Der Kunde selbst ist verpflichtet, die datenschutzrechtlichen Bestimmungen hinsichtlich des
                        Zugriffs seiner Mitarbeiter oder Dritter zu beachten. AllDayCare ist weder zur Beratung noch zur
                        Überwachung der Einhaltung der rechtlichen Bestimmungen verpflichtet. Die eigenen Pflichten von
                        AllDayCare, insbesondere als Auftragsverarbeiter und hinsichtlich der Sicherheit der eigenen
                        Systeme, bleiben hiervon unberührt.
                    </p>

                    <p class="text-gray-800">
                        Der Kunde ist verpflichtet, sein System nach dem jeweiligen Stand der Technik vor Viren,
                        Trojanern etc. zu schützen, um eine Infektion der Webapplikation zu vermeiden. Sollte er Kenntnis
                        von einem Befall haben, wird er AllDayCare hierüber unter genauer Angabe des Virus, des Trojaners
                        etc. unverzüglich informieren. Bei einer konkreten Gefährdung der Webapplikation oder anderer
                        Nutzer ist AllDayCare berechtigt, den betroffenen Zugang vorübergehend zu sperren; der Kunde wird
                        hierüber unverzüglich informiert.
                    </p>

                    <h3 class="mb-5 mt-7">
                        § 9 Mängel, Mangelbeseitigung
                    </h3>

                    <p class="text-gray-800">
                        Die vereinbarte Leistung ergibt sich aus der bei Vertragsschluss gültigen
                        <a href="/functions">Funktionsübersicht</a> (§ 2) und ist verbindlich. AllDayCare weist darauf
                        hin, dass Software nach dem Stand der Technik nicht für alle denkbaren Anwendungsbedingungen
                        völlig fehlerfrei erstellt werden kann; unerhebliche Abweichungen begründen keine Mängelrechte.
                    </p>

                    <p class="text-gray-800">
                        Weist die Webapplikation einen Mangel auf, der ihre Tauglichkeit zum vertragsgemäßen Gebrauch
                        aufhebt oder nicht nur unerheblich mindert, wird AllDayCare den Mangel nach Meldung innerhalb
                        angemessener Frist beseitigen. Die gesetzlichen Mängelrechte des Kunden – insbesondere das Recht
                        zur Minderung sowie, unter den gesetzlichen Voraussetzungen, zum Schadensersatz – bleiben
                        unberührt; die Haftung richtet sich nach § 10.
                    </p>

                    <p class="text-gray-800">
                        Der Kunde wird erkannte Mängel möglichst zeitnah in Textform (insbesondere per E-Mail) melden und
                        AllDayCare nachprüfbare Angaben zu Art und Auftreten der Abweichung zur Verfügung stellen
                        (z. B. Bildschirmaufnahmen oder Fehlerberichte) sowie bei der Eingrenzung von Fehlern mitwirken.
                        Eine verspätete Meldung führt nicht zum Verlust von Mängelrechten; sie kann jedoch bei der
                        Bemessung von Ansprüchen berücksichtigt werden, soweit AllDayCare dadurch die Mangelbeseitigung
                        erschwert oder ein Schaden vergrößert wurde.
                    </p>

                    <p class="text-gray-800">
                        Ein Einstehen für Fehler erstreckt sich nicht auf das Beseitigen von Problemen, die durch das
                        Abweichen von den für die Webapplikation vorgesehenen Einsatzbedingungen verursacht werden, sowie
                        auf Mängel in abgeänderten oder bearbeiteten Fassungen der Webapplikation, soweit nicht
                        nachgewiesen wird, dass vorhandene Mängel in keinem Zusammenhang mit den Änderungen oder
                        Bearbeitungen stehen.
                    </p>

                    <p class="text-gray-800">
                        Die Verjährung von Mängelansprüchen richtet sich nach den gesetzlichen Vorschriften. Die
                        Besonderheiten des Beta-Betriebs (insbesondere zur Verfügbarkeit und zur Datensicherung)
                        ergeben sich aus § 10.
                    </p>

                    <h3 class="mb-5 mt-7">
                        § 10 Beta-Version und Haftung
                    </h3>

                    <p class="text-gray-800">
                        (1) Die Webapplikation wird derzeit als <strong>Beta-Version</strong> bereitgestellt und
                        befindet sich in aktiver Weiterentwicklung. Der Vertragspartner erkennt an, dass es sich um eine
                        noch nicht abschließend fertiggestellte Software handelt, die getestet und laufend verbessert
                        wird. Der Beta-Status kann sich insbesondere in noch nicht vollständig ausgereiften Funktionen,
                        häufigeren Wartungen und einer gegenüber einer finalen Version eingeschränkten Servicequalität
                        auswirken.
                    </p>

                    <p class="text-gray-800">
                        (2) AllDayCare sichert für die Beta-Version keine bestimmte Verfügbarkeit und keinen bestimmten
                        Reaktions- oder Wiederherstellungszeitraum zu. Die gesetzlichen Mängelrechte des Kunden (§ 9)
                        sowie die nachstehenden Haftungsregelungen bleiben hiervon unberührt.
                    </p>

                    <p class="text-gray-800">
                        (3) Da die vom Kunden eingegebenen Daten auf Systemen von AllDayCare gespeichert werden und
                        derzeit keine Selbstbedienungs-Exportfunktion zur Verfügung steht, führt AllDayCare im Rahmen des
                        Beta-Betriebs nach Möglichkeit regelmäßige Sicherungen durch; eine bestimmte Wiederherstellbarkeit
                        wird im Beta-Stadium nicht zugesichert. Die Verantwortung für die Sicherung und Wiederherstellung
                        der auf den Systemen von AllDayCare gespeicherten Daten verbleibt insoweit bei AllDayCare. Auf
                        Anfrage stellt AllDayCare dem Kunden dessen Daten in einem gängigen Format zur Verfügung
                        (Datenherausgabe).
                    </p>

                    <p class="text-gray-800">
                        (4) AllDayCare ist berechtigt, einzelne Funktionen zu ändern, vorübergehend auszusetzen oder
                        einzustellen, soweit hierfür ein sachlicher Grund besteht. Änderungen wesentlicher, vom Kunden
                        gebuchter Funktionen kündigt AllDayCare mit angemessener Frist an. Werden wesentliche Funktionen
                        dauerhaft und für den Kunden nachteilig eingestellt, steht dem Kunden ein Sonderkündigungsrecht
                        zu; bereits im Voraus gezahlte Entgelte werden für den nicht genutzten Zeitraum anteilig
                        erstattet.
                    </p>

                    <p class="text-gray-800">
                        (5) AllDayCare haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder
                        der Gesundheit, für Vorsatz und grobe Fahrlässigkeit, für arglistig verschwiegene Mängel, im
                        Rahmen einer übernommenen Garantie sowie nach zwingenden gesetzlichen Vorschriften (insbesondere
                        nach dem Produkthaftungsgesetz und dem Datenschutzrecht).
                    </p>

                    <p class="text-gray-800">
                        (6) Bei einfacher Fahrlässigkeit haftet AllDayCare nur für die Verletzung einer wesentlichen
                        Vertragspflicht (Kardinalpflicht), deren Erfüllung die ordnungsgemäße Durchführung des Vertrages
                        überhaupt erst ermöglicht und auf deren Einhaltung der Kunde regelmäßig vertrauen darf. In diesem
                        Fall ist die Haftung auf den bei Vertragsschluss vorhersehbaren, vertragstypischen Schaden
                        begrenzt.
                    </p>

                    <p class="text-gray-800">
                        (7) Im Übrigen ist die Haftung von AllDayCare für einfache Fahrlässigkeit ausgeschlossen.
                    </p>

                    <p class="text-gray-800">
                        (8) Für den Verlust von Daten haftet AllDayCare im Rahmen der vorstehenden Absätze der Höhe nach
                        begrenzt auf den typischen Wiederherstellungsaufwand, der bei ordnungsgemäßer, regelmäßiger
                        Datensicherung durch AllDayCare angefallen wäre. Stellt AllDayCare dem Kunden künftig eine
                        Möglichkeit zur eigenen Datensicherung (z. B. einen Datenexport) zur Verfügung, gilt diese
                        Begrenzung entsprechend für eine dem Kunden mögliche und zumutbare eigene Sicherung.
                    </p>

                    <p class="text-gray-800">
                        (9) Die vorstehenden Haftungsbeschränkungen gelten auch für die persönliche Haftung der
                        gesetzlichen Vertreter, Mitarbeiter und Erfüllungsgehilfen von AllDayCare.
                    </p>

                    <h3 class="mb-5 mt-7">
                        § 11 Support und Reaktionszeiten (SLA)
                    </h3>

                    <p class="text-gray-800">
                        (1) Support-Anfragen können in Textform per E-Mail an info@alldaycare.de gerichtet werden.
                        Support wird in deutscher Sprache und ausschließlich samstags von 8:00 bis 17:00 Uhr (außer an
                        gesetzlichen Feiertagen am Sitz von AllDayCare) geleistet.
                    </p>

                    <p class="text-gray-800">
                        (2) AllDayCare bearbeitet Support-Anfragen innerhalb einer angestrebten
                        <strong>Reaktionszeit von sieben Kalendertagen</strong> ab Zugang der Anfrage. Als Reaktion gilt
                        die erste inhaltliche Rückmeldung von AllDayCare (z. B. eine Eingangs- und Bearbeitungsmitteilung
                        oder eine Rückfrage). Die Reaktionszeit ist keine Zusage einer Lösungs- oder
                        Wiederherstellungszeit; ein bestimmter Zeitpunkt der abschließenden Bearbeitung oder
                        Fehlerbehebung wird – insbesondere aufgrund des Beta-Status – nicht zugesichert.
                    </p>

                    <p class="text-gray-800">
                        (3) Ein garantiertes Service Level (z. B. eine bestimmte Verfügbarkeit oder eine verbindliche
                        Reaktions- oder Entstörzeit) ist mit dem Beta-Support nicht verbunden und wird nicht geschuldet,
                        sofern nicht gesondert in Textform etwas anderes vereinbart wird.
                    </p>

                    <h3 class="mb-5 mt-7">
                        § 12 Schlussbestimmungen
                    </h3>

                    <p class="text-gray-800">
                        (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts (CISG).
                    </p>

                    <p class="text-gray-800">
                        (2) Ist der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches
                        Sondervermögen, ist ausschließlicher Gerichtsstand für alle Streitigkeiten aus und im Zusammenhang
                        mit diesem Vertrag der Sitz von AllDayCare. AllDayCare ist berechtigt, auch am allgemeinen
                        Gerichtsstand des Kunden zu klagen.
                    </p>

                    <p class="text-gray-800">
                        (3) Änderungen und Ergänzungen dieses Vertrages bedürfen der Textform. Mündliche Nebenabreden
                        bestehen nicht.
                    </p>

                    <p class="text-gray-800">
                        (4) Der Kunde kann Rechte und Pflichten aus diesem Vertrag nur mit vorheriger Zustimmung von
                        AllDayCare auf Dritte übertragen. Ein Zurückbehaltungsrecht oder eine Aufrechnung stehen dem
                        Kunden nur wegen unbestrittener oder rechtskräftig festgestellter Gegenforderungen zu.
                    </p>

                    <p class="text-gray-800">
                        (5) Umstände höherer Gewalt, die AllDayCare die vertragsgemäße Leistung wesentlich erschweren oder
                        unmöglich machen (z. B. großflächige Störungen von Telekommunikations- oder Hosting-Infrastruktur,
                        behördliche Maßnahmen, Naturereignisse), befreien AllDayCare für ihre Dauer von der
                        Leistungspflicht; hierüber wird der Kunde informiert.
                    </p>

                    <p class="text-gray-800">
                        (6) Sollten einzelne Bestimmungen dieses Vertrages unwirksam oder undurchführbar sein oder werden,
                        so bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. An die Stelle einer unwirksamen oder
                        undurchführbaren Bestimmung treten die gesetzlichen Regelungen.
                    </p>


                </div>
                <div class="col-12 col-md-4">

                    <NeedHelpComponent />

                </div>
            </div> <!-- / .row -->
        </div> <!-- / .container -->
    </section>
</template>

<script>
import NavBar from '@/components/Shared/NavBar.vue';
import NeedHelpComponent from '@/components/NeedHelpComponent.vue';

export default {
    components: {
        NavBar,
        NeedHelpComponent
    },
    methods: {
        printPage() {
            window.print();
        }
    }
}
</script>